interface ContactFormConfig {
  cf7Id: number;
  cf7UnitTag: string;
  nonce: string;
}
declare const contactForm: ContactFormConfig;
declare const turnstile: { reset: () => void } | undefined;

interface CF7Response {
  status: 'mail_sent' | 'validation_failed' | 'spam' | 'mail_failed';
  message: string;
  invalid_fields: { field: string; message: string }[];
}

export interface FormOptions {
  formId: string;
  completeUrl: string;
  onInit?: (form: HTMLFormElement) => boolean;
  beforeSubmit?: (formData: FormData) => void;
}

export function initContactForm(options: FormOptions): void {
  const form = document.getElementById(
    options.formId
  ) as HTMLFormElement | null;
  if (!form) return;

  if (options.onInit && !options.onInit(form)) return;

  // 郵便番号: zip1が maxlength に達したら zip2 へフォーカス移動
  const zip1 = form.querySelector<HTMLInputElement>('input[name="your-zip1"]');
  const zip2 = form.querySelector<HTMLInputElement>('input[name="your-zip2"]');
  if (zip1 && zip2) {
    zip1.addEventListener('input', () => {
      if (zip1.value.length >= (zip1.maxLength || 3)) {
        zip2.focus();
      }
    });
  }

  const submitBtn = form.querySelector<HTMLButtonElement>(
    'button[type="submit"]'
  );

  const updateSubmitState = () => {
    if (!submitBtn) return;
    const requiredFields =
      form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
        '[required]'
      );
    const allFilled = Array.from(requiredFields).every((field) => {
      if (field instanceof HTMLInputElement && field.type === 'checkbox') {
        return field.checked;
      }
      return field.value.trim() !== '';
    });
    submitBtn.disabled = !allFilled;
  };

  form
    .querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('[required]')
    .forEach((field) => {
      const event =
        field instanceof HTMLInputElement && field.type === 'checkbox'
          ? 'change'
          : 'input';
      field.addEventListener(event, updateSubmitState);
    });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (submitBtn) submitBtn.disabled = true;

    form.querySelectorAll<HTMLSpanElement>('.error-message').forEach((el) => {
      el.textContent = '';
    });
    const status = document.getElementById('form-status')!;
    status.textContent = '';

    const formData = new FormData(form);
    formData.append('_wpcf7', String(contactForm.cf7Id));
    formData.append('_wpcf7_unit_tag', contactForm.cf7UnitTag);
    formData.append('_wpnonce', contactForm.nonce);

    if (options.beforeSubmit) {
      options.beforeSubmit(formData);
    }

    try {
      const res = await fetch(
        `/wp-json/contact-form-7/v1/contact-forms/${contactForm.cf7Id}/feedback`,
        { method: 'POST', body: formData }
      );
      const data: CF7Response = await res.json();

      if (data.status === 'mail_sent') {
        window.location.href = options.completeUrl;
      } else if (data.status === 'validation_failed') {
        data.invalid_fields.forEach(({ field, message }) => {
          if (!field) return;
          const el = form.querySelector<HTMLSpanElement>(
            `[data-field="${field}"]`
          );
          if (el) el.textContent = message;
        });
        status.textContent = data.message;
        status.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        status.textContent = data.message || '送信に失敗しました。';
        status.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch {
      status.textContent = '通信エラーが発生しました。';
      status.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } finally {
      updateSubmitState();
    }

    if (typeof turnstile !== 'undefined') {
      turnstile.reset();
    }
  });
}
